
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

var $55da0d350bfec3fd$exports = {};

(parcelRequire("02nRr")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"1WXdc\",\"CommentEditor.51e916f5.js\",\"764nc\",\"tooltip.190980da.js\",\"faXeM\",\"main.73c3a6d9.js\",\"1bbSu\",\"FullPageEditorComponent.a065717e.js\",\"7eOUa\",\"main.411da867.js\",\"9zjWJ\",\"main.130f568a.js\",\"cwwPf\",\"main.223237ba.js\",\"3a4K1\",\"main.69ce35f5.js\",\"9J4KV\",\"cs.79cc96b9.js\",\"8Y9JE\",\"da.79c4c307.js\",\"gWrRN\",\"de.ae1b3783.js\",\"irKcy\",\"en.f4af87ab.js\",\"1aghR\",\"en_GB.fb839892.js\",\"3jFnE\",\"en_ZZ.513dcb81.js\",\"11Khz\",\"es.4e947d24.js\",\"ap0LY\",\"et.e75ca3b6.js\",\"34Ma8\",\"fi.62c82fa5.js\",\"lBwDa\",\"fr.10f1c5d5.js\",\"32Pvr\",\"hu.46d44a08.js\",\"b7bFd\",\"is.d9772209.js\",\"6h8Ae\",\"it.c4d5b168.js\",\"dW8Ws\",\"ja.ef067cf3.js\",\"fJZdm\",\"ko.2b2a50ac.js\",\"kfTIE\",\"nb.08da7f15.js\",\"b8M9e\",\"nl.7c1d6e2a.js\",\"jMchi\",\"pl.d33b983c.js\",\"2xsmF\",\"pt_BR.d0af9c69.js\",\"hHyCx\",\"pt_PT.77e6008a.js\",\"gw4Pw\",\"ro.7a5f0e93.js\",\"8rhcn\",\"ru.81f4d1ac.js\",\"fh5Vk\",\"sk.173f2352.js\",\"aP4eD\",\"sv.d868e21e.js\",\"aJWAE\",\"th.271749e0.js\",\"b96A2\",\"tr.4d7fad3d.js\",\"g0ukK\",\"uk.55224b9d.js\",\"8DuKk\",\"vi.dbfa430b.js\",\"5aSRq\",\"zh_TW.d42b650f.js\",\"eQT38\",\"zh.bb9ca436.js\"]"));


$parcel$global.rlb("lTK3c")
//# sourceMappingURL=CommentEditor.runtime.7740746d.js.map
